export var ABTEST = 'ABTest';
export var ACCORDION = 'Accordion';
export var ACCORDIONITEM = 'AccordionItem';
export var ADVERTISERDISCLOSURE = 'AdvertiserDisclosure';
export var ANCHORLINK = 'AnchorLink';
export var ANCHORLINKTARGET = 'AnchorLinkTarget';
export var APOLLOINTEGRATIONCANARY = 'ApolloIntegrationCanary';
export var ARTICLEHERO = 'ArticleHero';
export var AUTHLINK = 'AuthLink';
export var AUTHORSBOX = 'AuthorsBox';
export var AUTOINSURANCEBANNER = 'AutoInsuranceBanner';
export var AUTOINSURANCEDRCFIELD = 'AutoInsuranceDRCField';
export var AUTOINSURANCEDRCPROVIDER = 'AutoInsuranceDRCProvider';
export var AUTOINSURANCEDRCTABLE = 'AutoInsuranceDRCTable';
export var AUTOINSURANCEDRCCITYTABLE = 'AutoInsuranceDRCCityTable';
export var AUTOINSURANCEDRCMODELLIST = 'AutoInsuranceDRCModelList';
export var AUTOINSURANCEDRCVEHICLETABLE = 'AutoInsuranceDRCVehicleTable';
export var AUTOINSURANCEENTRYPOINT = 'AutoInsuranceEntryPoint';
export var AUTOINSURANCEQUOTES = 'AutoInsuranceQuotes';
export var BACKTOTOPLINK = 'BackToTopLink';
export var BANNER = 'Banner';
export var BUTTON = 'Button';
export var CALCULATEDFIELDSFORM = 'CalculatedFieldsForm';
export var CALCULATION = 'Calculation';
export var CALCULATOR = 'Calculator';
export var CALCULATORCONDITIONAL = 'CalculatorConditional';
export var CALCULATORINPUT = 'CalculatorInput';
export var CALCULATORRADIO = 'CalculatorRadio';
export var CALCULATORSELECT = 'CalculatorSelect';
export var CARD = 'Card';
export var CREDITCARDSROUNDUPWITHCOMPAREBAR = 'CreditCardsRoundupWithCompareBar';
export var CITATION = 'Citation';
export var CITATIONLIST = 'CitationList';
export var COLUMN = 'Column';
export var COLUMNS = 'Columns';
export var CONTAINER = 'Container';
export var CONTENTHEADING = 'ContentHeading';
export var CONTENTIMAGE = 'ContentImage';
export var CONTENTPAGEHEADER = 'ContentPageHeader';
export var CONTENTQUOTE = 'ContentQuote';
export var CREDITCARDSABOVESECTIONS = 'CreditCardsAboveSections';
export var CREDITCARDSROUNDUPRECAPSECTION = 'CreditCardsRoundupRecapSection';
export var CREDITCARDSROUNDUPSUMMARYTABLE = 'CreditCardsRoundupSummaryTable';
export var DIVIDER = 'Divider';
export var DOCUMENT = 'Document';
export var DROPCAPS = 'DropCaps';
export var FAQ = 'FAQ';
export var FUNDERALOANOPTIONCTA = 'FunderaLoanOptionCta';
export var HEADING = 'Heading';
export var HIGHLIGHTSLIST = 'HighlightsList';
export var HIGHLIGHTEDFACTS = 'HighlightedFacts';
export var HLMENTRY = 'HlmEntry';
export var HLMGENERICENTRY = 'HlmGenericEntry';
export var HLMREFINANCEENTRY = 'HlmRefinanceEntry';
export var HOMEINSURANCEBANNER = 'HomeInsuranceBanner';
export var HOMEINSURANCEENTRYPOINT = 'HomeInsuranceEntryPoint';
export var HOUSEAD = 'HouseAd';
export var IMAGE = 'Image';
export var INFOGRAM = 'Infogram';
export var INSTAGRAM = 'Instagram';
export var INSURANCEPRODUCTCARD = 'InsuranceProductCard';
export var LENDINGPRODUCTCARD = 'LendingProductCard';
export var LIFEINSURANCEBANNER = 'LifeInsuranceBanner';
export var LIFEINSURANCEQUOTES = 'LifeInsuranceQuotes';
export var LINK = 'Link';
export var LIST = 'List';
export var LISTITEM = 'Li';
export var LOANESTIMATEENTRYPOINT = 'LoanEstimateEntryPoint';
export var LOCATIONDATAFIELD = 'LocationDataField';
export var LOCATIONDATAPROVIDER = 'LocationDataProvider';
export var LOGOSROW = 'LogosRow';
export var MARKETPLACEAPPLYNOW = 'MarketplaceApplyNow';
export var MARKETPLACECOMPARISONLINK = 'MarketplaceComparisonLink';
export var MARKETPLACECOMPARISONTABLE = 'MarketplaceComparisonTable';
export var MARKETPLACEENTITYDISPLAYNAME = 'MarketplaceEntityDisplayName';
export var MARKETPLACEENTITYLOGOROW = 'MarketplaceEntityLogoRow';
export var MARKETPLACEENTRYPOINT = 'MarketplaceEntryPoint';
export var MARKETPLACEFIELD = 'MarketplaceField';
export var MARKETPLACEPARTNERPLACEMENT = 'MarketplacePartnerPlacement';
export var MARKETPLACEPRODUCTCARD = 'MarketplaceProductCard';
export var CREDITCARDSMARKETPLACEPRODUCTCARD = 'CreditCardsMarketplaceProductCard';
export var MARKETPLACERATETABLE = 'MarketplaceRateTable';
export var MARKETPLACESTARRATING = 'MarketplaceStarRating';
export var MARKETPLACETHIRDPARTYEMBED = 'MarketplaceThirdPartyEmbed';
export var MEGAPHONEFM = 'MegaphoneFm';
export var MINIPRODUCTCARD = 'MiniProductCard';
export var MORELIKETHISLIST = 'MoreLikeThisList';
export var MORELINK = 'MoreLink';
export var MORTGAGELENDERINTERACTIVECOMPARISON = 'MortgageLenderInteractiveComparison';
export var NERDYTAKEAWAY = 'NerdyTakeaway';
export var NERDTIP = 'NerdTip';
export var NOOP = 'NoOp';
export var SMBCOMPARELOANSENTRYPOINT = 'SMBCompareLoansEntryPoint';
export var OUTOFDATEMESSAGE = 'OutOfDateMessage';
export var OUTSIDEEXPERT = 'OutsideExpert';
export var POSTLIST = 'PostList';
export var PREQUALAPPLICATIONHOUSEAD = 'PrequalApplicationHouseAd';
export var PREQUALBANNER = 'PrequalBanner';
export var PRODUCTSTARRATING = 'ProductStarRating';
export var QUESTIONLIST = 'QuestionList';
export var RENDERCONTEXTCONDITIONAL = 'RenderContextConditional';
export var RENTERSINSURANCEENTRYPOINT = 'RentersInsuranceEntryPoint';
export var REVIEWDETAILSOFFER = 'ReviewDetailsOffer';
export var REVIEWINTROOFFER = 'ReviewIntroOffer';
export var REVIEWJSONLD = 'ReviewJsonLd';
export var CREDITCARDSROUNDUPCATEGORYSECTION = 'CreditCardsRoundupCategorySection';
export var CREDITCARDSUPDATEDDATESECTION = 'CreditCardsUpdatedDateSection';
export var ROUNDUPJSONLD = 'RoundupJsonLd';
export var SCREENSIZECONDITIONAL = 'ScreenSizeConditional';
export var SCROLLDEPTHCONDITIONAL = 'ScrollDepthConditional';
export var SOCIALMEDIALINKS = 'SocialMediaLinks';
export var SOCIALMEDIASHARELINKS = 'SocialMediaShareLinks';
export var SPOTIFY = 'Spotify';
export var STARRATING = 'StarRating';
export var STICKYCONTAINER = 'StickyContainer';
export var TABLE = 'Table';
export var TABLEOFCONTENTS = 'TableOfContents';
export var TABLEOFCONTENTSTARGET = 'TableOfContentsTarget';
export var TIKTOK = 'TikTok';
export var TITLE = 'Title';
export var TOOLLIST = 'ToolList';
export var TOOLLISTITEM = 'ToolListItem';
export var TWITTER = 'Twitter';
export var TYPE = 'Type';
export var USERSEGMENTCONDITIONAL = 'UserSegmentConditional';
export var VIDEO = 'Video';
export var WELL = 'Well';
export var WPAUTHORSBOX = 'WPAuthorsBox';
export var WPBIOHEADER = 'WPBioHeader';
export var WPBLOCK = 'WPBlock';
export var WPCALCULATOR = 'WPCalculator';
export var WPCCROUNDUPCROSSSELL = 'WPCCRoundupCrossSell';
export var WPCONTENTPAGEHEADER = 'WPContentPageHeader';
export var WPEMBED = 'WPEmbed';
export var WPFEATUREDIMAGE = 'WPFeaturedImage';
export var WPHOUSEAD = 'WPHouseAd';
export var WPINLINEBLOCK = 'WPInlineBlock';
export var WPMARKETPLACEENTRYPOINT = 'WPMarketplaceEntryPoint';
export var WPMETHODOLOGY = 'WPMethodology';
export var WPPOSTLIST = 'WPPostList';
export var WPSOCIALMEDIALINKS = 'WPSocialMediaLinks';
export var WPTABLE = 'WPTable';